<template>
    <div>
      <TaskCenterNoList 
        :missionStatus="missionStatus"
      />
      <div v-if="missionStatus===1 || missionStatus===3">
        <SubTask 
          v-if="getTaskListData.length==1"
          key="1"
          :activityID="activityID"
          :getTaskListData="getTaskListData"
          @getcurrentdata="getcurrentdata"
          @handleUse="handleUse"
        />
        <SubTask 
          v-else-if="getTaskListData.length==2"
          key="2"
          :activityID="activityID"
          :getTaskListData="getTaskListData"
          @getcurrentdata="getcurrentdata"
          @handleUse="handleUse"
        />
        <SubTask
          v-else
          key="3"
          :activityID="activityID"
          :getTaskListData="getTaskListData"
          @getcurrentdata="getcurrentdata"
          @handleUse="handleUse"
        />
        <AwardDesc 
          :descThirdLine="getDescThirdLine"
          :getTaskListData="getTaskListData"
        />
        <AwardCoupon 
          :couponData="getCouponData" 
          :isHasReward="currentTaskData.isHasReward"
          :isCompleteMission="currentTaskData.isReceiveReward"
          @handleUse="handleUse"
        />
      </div>
    </div>
</template>
<script>
import {homepageTaskCenterLandingSw, homepageTaskCouponRealexposureSw, homepageTaskOrderButtonCk} from '../trackEvent'

import TaskCenterNoList from './taskCenterNoList.vue'
import SubTask from './subTask/index.vue'
import AwardDesc from './subAward/awardDesc.vue'
import AwardCoupon from './subAward/awardCoupon.vue'
export default {
  name: 'TaskCenterMain',
  components: {
    TaskCenterNoList,
    SubTask,
    AwardDesc,
    AwardCoupon
  },
  props: {
    activityID: {
      default: ''
    },
    missionStatus: {
      default: ''
    },
    missionProgressReward: {
      default: () => []
    },
    isOtherActivity: {
      default: 2
    }
  },
  computed: {
    getCouponData () {
      let coupon = {}
      if (this.currentTaskData && this.currentTaskData.rewardStrategy) {
        coupon = {
          ...this.currentTaskData.rewardStrategy[0],
          customerLogo: this.currentTaskData.rewardStrategy[0].customLogo
        }
      }
      return coupon
    },
    getDescThirdLine () {
      return this.currentTaskData && this.currentTaskData.descThirdLine
    },
    getTaskListData () {
      return this.missionProgressReward.map((item, index) => {
        return {
          index: index,
          ladderNum: item.ladderNum, // 任务阶梯
          descFirstLine: item.descFirstLine, // 第一行文案
          descSecondLine: item.descSecondLine, // 第二行文案
          isCompleteMission: item.isCompleteMission, // 是否完成当前子任务
          isHasReward: item.isHasReward, // 当前子任务是否有奖励
          isReceiveReward: item.isReceiveReward, // 是否领取当前任务奖励
          justGetThe: item.justGetThe, // 是否是刚刚领取完成任务
          betweenNextFocusNode: item.betweenNextFocusNode, // 进度
          rewardStrategy: item.rewardStrategy
        }
      })
    }
  },
  data () {
    return {
      firstGetData: false,
      currentTaskData: {},
      swGather: [],
      currentLaddereNum: '',
      currentActiveIndex: 0
    }
  },
  watch: {
    currentTaskData: {
      handler: function (newV) {
        const firstCouponData = newV && newV.rewardStrategy && (newV.rewardStrategy[0] || {})
        const ladderNum = (newV && newV.ladderNum) || ''

        if (this.firstGetData) {
          this.landingSw(firstCouponData)
          this.firstGetData = false
          this.swGather.push(ladderNum)
          return
        }
        // 有奖励，且曝光过不再进行曝光
        if (this.swGather.includes(ladderNum)) return
        if (newV && newV.isHasReward) {
          this.realexposureSw(firstCouponData)
          this.swGather.push(ladderNum)
        }
      }
    },
    missionProgressReward () {
      this.currentLaddereNum && this.getcurrentdata(this.currentLaddereNum, this.currentActiveIndex)
    },
    getCouponData: {
      handler: function (newV) {
        this.$emit('getTaskOrderButtonCkData', newV)
      },
      deep: true
    }
  },
  mounted () {
    this.firstGetData = true
  },
  methods: {
    getcurrentdata (ladderNum, index) {
      this.$emit('getCurrentTaskStyle', index, 'request', ladderNum)
      this.currentActiveIndex = index
      this.currentLaddereNum = ladderNum
      this.currentTaskData = (this.missionProgressReward.filter(item => item.ladderNum === ladderNum)[0]) || {}
    },
    handleUse (val, type) {
      if (type === 'couponButton') {
        let taskNum = 0
      if (this.getTaskListData[0].ladderNum == -1) { // eslint-disable-line
          taskNum = this.getTaskListData.length - 1
        } else {
          taskNum = this.getTaskListData.length
        }
        homepageTaskOrderButtonCk({
          button_type: 3,
          task_num: taskNum
        })
      }
      if (val.ladderNum) {
        this.$emit('handleUse', val)
        this.$emit('getCurrentTaskStyle', val.index, 'click')
        return
      }
      // 处理一下数据
      this.$emit('getCurrentTaskStyle', this.currentActiveIndex, 'click')
      this.$emit('handleUse', {
        ladderNum: this.currentTaskData.ladderNum,
        btnStatus: this.currentTaskData.rewardStrategy[0].buttons[0].status
      })
    },
    getTaskStatus () {
      // 服务端任务状态和埋点不一致
      const missionStatus = {
        1: 1,
        2: 3,
        3: 2
      }
      return missionStatus[this.missionStatus]
    },
    getCouponKeyValue (source, key) {
      return (source && source[key]) || ''
    },
    getCouponStatus (source) {
      return source && source.buttons && (source.buttons.length === 0 ? 3 : source.buttons[0].status)
    },
    getTaskList () {
      let data = JSON.parse(JSON.stringify(this.missionProgressReward))
      if(data[0].ladderNum==-1) { // eslint-disable-line
        data.shift()
      }
      const list = data.map((item, index) => {
        return {
          number: index + 1,
          statue: item.isCompleteMission ? 1 : 0, // statue:节点状态（1 完成 0 未完成）
          has_coupon: item.isHasReward ? 1 : 0, // has_coupon:是否有券（0 无 1 有）
          has_reward: item.isHasReward ? 1 : 0// has_reward：是否有奖励（0 无 1有）
        }
      })
      return JSON.stringify(list)
    },
    landingSw (firstCouponData) {
      let taskNum = 0
      if (this.getTaskListData[0].ladderNum == -1) { // eslint-disable-line
        taskNum = this.getTaskListData.length - 1
      } else {
        taskNum = this.getTaskListData.length
      }
      homepageTaskCenterLandingSw({
        activity_id: this.activityID,
        task_list: this.getTaskList(),
        task_status: this.getTaskStatus(),
        coupon_id: this.getCouponKeyValue(firstCouponData, 'couponId'),
        batch_id: this.getCouponKeyValue(firstCouponData, 'batchId'),
        coupon_type: 1,
        coupon_status: this.getCouponStatus(firstCouponData),
        is_other_activity: this.isOtherActivity,
        task_number: this.currentActiveIndex, // 当前节点序号（n）
        task_num: taskNum, // 节点数量
        activity_type: 1 // 1 订单任务2 消费任务
      })
    },
    realexposureSw (firstCouponData) {
      homepageTaskCouponRealexposureSw({
        activity_id: this.activityID,
        coupon_id: this.getCouponKeyValue(firstCouponData, 'couponId'),
        batch_id: this.getCouponKeyValue(firstCouponData, 'batchId'),
        coupon_type: 1,
        coupon_status: this.getCouponStatus(firstCouponData),
        activity_type: 1 // 1 订单任务2 消费任务
      })
    }
  }
}
</script>